import { RootState, Status } from '../types';
import { MatchWithNotes } from '../types/notes';

export const getNotesStatus = (state: RootState): Status => state.notes.status;

export const getNotepad = (state: RootState): string => state.notes.notepad;

export const getNotesByMatches = (state: RootState): MatchWithNotes[] => state.notes.notesByMatches;
